import '/src/styles/global.scss'

if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual'
}

export const shouldUpdateScroll = () => false

export const onRouteUpdate = () => {
  requestAnimationFrame(() => {
    window.scrollTo(0, 0)
  })
}
